<template>
	<div class="flex flex-col w-full justify-center items-center p-6">
		<div class="w-full max-w-8xl">
			<div v-if="!birthKits" class="flex flex-col md2:flex-row space-y-4 md2:space-y-0 w-full justify-between my-12 md:my-6">
				<div class="flex w-full max-w-xs">
					<div class="text-lg font-semibold text-ihh-midnight-gray mr-4 m-auto whitespace-nowrap">Sort By:</div>
					<select
						v-model="sort"
						class="cursor-pointer focus:border focus:border-ihh-dark-salmon focus:outline-0 focus:shadow shadow-ihh-dark-salmon flex w-full md2:mr-4 border rounded-lg py-3 px-2 bg-ihh-slate-gray/20 text-ihh-midnight-gray font-bold text-xs tracking-wide"
					>
						<option v-for="so in sortOptions" :value="so.id">{{ so.name }}</option>
						<!-- <option value="Featured Items">Featured Items</option>
						<option value="Newest Items">Newest Items</option>
						<option value="Best Selling" selected>Best Selling</option>
						<option value="A to Z">A to Z</option>
						<option value="Z to A">Z to A</option>
						<option value="By Review">By Review</option>
						<option value="Price: Ascending">Price: Ascending</option>
						<option value="Price: Descending">Price: Descending</option> -->
					</select>
				</div>

				<div id="filters-button" class="flex w-full max-w-sm lg:hidden">
					<button
						class="group flex-row w-full m-auto items-center justify-center text-center text-sm font-semibold text-ihh-midnight-gray hover:text-ihh-white border-3 border-ihh-dark-salmon px-4 py-3 rounded-lg hover:bg-ihh-dark-salmon duration-100"
						@click="showFilters = !showFilters"
					>
						<div class="inline-flex items-center m-auto gap-x-3 mt-1.5">
							<svg class="w-5 font-bold fill-ihh-midnight-gray group-hover:fill-ihh-white rotate-90" viewBox="0 0 1024 1024">
								<path
									d="M640 288a64 64 0 1 1 0.032-128.032A64 64 0 0 1 640 288z m123.456-96c-14.304-55.04-64-96-123.456-96s-109.152 40.96-123.456 96H128v64h388.544c14.304 55.04 64 96 123.456 96s109.152-40.96 123.456-96H896V192h-132.544zM640 864a64 64 0 1 1 0.032-128.032A64 64 0 0 1 640 864m0-192c-59.456 0-109.152 40.96-123.456 96H128v64h388.544c14.304 55.04 64 96 123.456 96s109.152-40.96 123.456-96H896v-64h-132.544c-14.304-55.04-64-96-123.456-96M384 576a64 64 0 1 1 0.032-128.032A64 64 0 0 1 384 576m0-192c-59.456 0-109.152 40.96-123.456 96H128v64h132.544c14.304 55.04 64 96 123.456 96s109.152-40.96 123.456-96H896v-64H507.456c-14.304-55.04-64-96-123.456-96"
								/>
							</svg>
							<span class="">Filters</span>
							<span v-if="numberFilters" class="text-ihh-midnight-gray font-semibold">({{ number }})</span>
						</div>
					</button>
				</div>
			</div>

			<template v-else>
				<div v-if="category?.name === 'Custom Birth Kits by Midwife'" class="w-full text-ihh-midnight-gray font-semibold tracking-wide mb-12 text-center space-y-4">
					<div>Please use the search box below to find your midwife's kit under her name or midwifery practice name.</div>
					<div>
						<input
							v-model="filters.query"
							class="px-3 py-2 rounded border w-full max-w-xs focus:outline-none focus:ring-2 focus:ring-ihh-dark-salmon focus:border-0"
							placeholder="Search Birth Kits"
						/>
					</div>
				</div>
			</template>

			<div
				id="mobile-filters"
				class="h-screen fixed top-0 left-0 z-40 select-none w-full bg-ihh-dark-gray/60 bg-local backdrop-blur-sm"
				:class="showFilters ? '' : '-translate-x-full'"
				@click="showFilters = !showFilters"
			>
				<div class="flex w-full justify-start h-full">
					<div
						class="w-full max-w-[360px] bg-ihh-white xs:rounded-r-xl flex flex-col transform transition-transform rounded-r-lg delay-200 duration-300 ease-in-out"
						:class="showFilters ? '' : '-translate-x-full'"
						@click.stop
					>
						<!-- Mobile Header - Always visible at top -->
						<div class="flex w-full p-6 bg-ihh-dark-gray z-30 items-center sticky top-0">
							<div class="text-ihh-white flex w-full justify-start text-start text-base" @click="showFilters = !showFilters">Back</div>
							<div class="flex w-full justify-end">
								<button @click="showFilters = !showFilters" class="group w-4 h-4 justify-around flex text-xl py-4 rounded-full">
									<div class="m-auto items-center flex w-full justify-center">
										<div class="rotate-45 absolute bg-ihh-white py-px rounded px-2"></div>
										<div class="-rotate-45 bg-ihh-white py-px rounded px-2"></div>
									</div>
								</button>
							</div>
						</div>

						<!-- Scrollable content area -->
						<div class="flex-1 overflow-y-auto overflow-x-hidden">
							<div class="pb-8">
								<RefineBy
									v-if="!birthKits"
									v-model:showFilters="showFilters"
									:refineByFilters="refineByFilters"
									:categoryId="categoryId"
									@price-range-change="updatePriceRange"
									@filter-change="handleFilterChange"
									mobile-mode="true"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="flex w-full justify-between">
				<div class="hidden lg:block">
					<RefineBy
						v-if="!birthKits"
						v-model:showFilters="showFilters"
						:refineByFilters="refineByFilters"
						:categoryId="categoryId"
						@price-range-change="updatePriceRange"
						@filter-change="handleFilterChange"
					/>
				</div>
				<SearchFilters class="w-full justify-end" :algoliaFilters="algoliaFilters" :mangoSearch="mangoSearch" :sort="mangoSort" :birthKits="birthKits" />
			</div>
		</div>
	</div>
</template>

<script>
import AddedFilters from './added-filters.vue'
import SearchFilters from './search-filters.vue'
import Shipping from './shipping.vue'
import axios from 'axios'
import RefineBy from './refine-by.vue'

export default {
	components: { AddedFilters, SearchFilters, Shipping, RefineBy },
	props: ['category', 'filterNames'],
	inject: ['store'],
	data() {
		return {
			filters: {
				categories: [this.category],
				query: '',
				price: [0, null],
				customFilters: {},
				brandIds: [], // Store brand IDs separately
			},
			sort: this.$route.path.includes('birth-kits') ? 'alpha_desc' : 'best_selling',
			sortOptions: [
				{
					name: 'Best Selling',
					id: 'best_selling',
				},
				{
					name: 'Featured',
					id: 'featured',
				},
				{
					name: 'Newest',
					id: 'newest',
				},
				{
					name: 'A to Z',
					id: 'alpha_asc',
				},
				{
					name: 'Z to A',
					id: 'alpha_desc',
				},
				{
					name: 'Average Customer Review',
					id: 'avg_customer_review',
				},
				{
					name: 'Price: Ascending',
					id: 'price_asc',
				},
				{
					name: 'Price: Descending',
					id: 'price_desc',
				},
			],
			numberFilters: false,
			info: false,
			coupon: false,
			certificate: false,
			showFilters: false,
			showFilters: false,
			refineByFilters: [],
			details: [
				{ name: `Help Center`, path: `/help-center` },
				{ name: `Returns`, path: `/returns` },
				{ name: `Ordering & Shipping Info`, path: `/shipping-info` },
				{ name: `Discount Code Terms`, path: `/discount-code-terms` },
				{ name: `Gift Certificates`, path: `/gift-certificates` },
				//   { name: `Custom Birth Kit Service`, path: `/water-birth123` },
				//   { name: `About Us`, path: `/water-birth123` },
				{ name: `Sitemap`, path: `/sitemap` },
			],
		}
	},

	async mounted() {
		if (this.category.defaultProductSort === 'use_store_settings') {
			this.sort = 'best_selling'
		} else {
			let categorySort = this.sortOptions.find((s) => s.id === this.category.defaultProductSort)
			this.sort = categorySort?.id || 'best_selling'
		}
		await this.fetchRefineByFilters()
	},

	methods: {
		// Handle filter changes from the RefineBy component
		async handleFilterChange(selectedFilters) {
			console.log('Filter change received:', selectedFilters)

			// Update the custom filters object
			this.filters.customFilters = {}
			// Store brand IDs separately for query building
			this.filters.brandIds = []

			// Count the number of active filters for the UI badge
			let filterCount = 0

			// Process each filter type
			Object.entries(selectedFilters).forEach(([filterName, values]) => {
				if (values && values.length) {
					filterCount += values.length

					// Handle different filter types
					if (filterName === 'Rating') {
						// Store Rating filter values directly
						this.filters.customFilters[filterName] = values
						console.log('Rating filter set:', values)
					} else if (filterName !== 'Price') {
						// Handle Brand filter specially to extract IDs
						if (filterName === 'Brand') {
							// Store brand names for display
							this.filters.customFilters[filterName] = values.map((v) => (typeof v === 'object' ? v.name : v))
							// Store brand IDs for querying
							this.filters.brandIds = values.filter((v) => typeof v === 'object' && v.id).map((v) => v.id)
						} else {
							this.filters.customFilters[filterName] = values
						}
					}
				}
			})

			// Update the filter count for the UI
			this.numberFilters = filterCount > 0

			// If Price filter has been removed, reset the price range inputs
			if (!selectedFilters.Price && this.filters.customFilters.Price) {
				delete this.filters.customFilters.Price
				// Emit price range change with reset values
				this.$emit('price-range-change', { min: 0, max: 1000 })
			}

			await this.fetchRefineByFilters()

			// Force a re-render of the SearchFilters component
			this.$forceUpdate()
		},

		// Update price range when changed in the RefineBy component
		updatePriceRange({ min, max }) {
			// Update the price filter values
			this.filters.price[0] = min
			this.filters.price[1] = max

			// Force a re-render of the SearchFilters component
			this.$forceUpdate()
		},

		async fetchRefineByFilters() {
			try {
				// Fetch filter configurations
				const response = await axios.post(`${this.store.api}/controllers/bigCommerce/products`, { search: this.mangoSearch, filters: this.filterNames })
				this.refineByFilters = response.data
			} catch (error) {
				console.error('Error fetching refineByFilters:', error)
			}
		},
	},

	computed: {
		categoryId() {
			return this.category?.id || ''
		},
		birthKits() {
			return this.$route.path.includes('birth-kits')
		},
		algoliaFilters() {
			if (this.birthKits) return
			if (!this.category) return
			let subCategories = this.store?.categories?.filter((c) => c.parentId == this.category.bcId) || []
			let all = [this.category, ...subCategories]
			return `(${all.map((c) => `categories.id:${c.id}`).join(' OR ')})`
		},
		number() {
			// Count the total number of active filters for display
			let count = 0

			// Count custom filters
			Object.values(this.filters.customFilters).forEach((values) => {
				count += values.length
			})

			// Count price filter if active
			if (this.filters.price[0] > 0 || this.filters.price[1] !== null) {
				count++
			}

			// Count search query if active
			if (this.filters.query && this.filters.query.trim().length > 0) {
				count++
			}

			return count
		},
		mangoSearch() {
			if (!this.store?.categories) return
			let baseFilters = { isVisible: true }
			if (this.birthKits) baseFilters.deleted = { $ne: true }
			let categories = this.filters.categories
			// if (!categories?.length) return baseFilters
			let subCategories = this.store?.categories?.filter((sc) => categories.find((c) => sc.parentId == c.bcId)) || []
			let all = [...categories, ...subCategories]

			// Build the query based on category and basic filters
			let calculatedPrice = { $gt: this.filters.price[0] }
			if (!!this.filters.price[1]) calculatedPrice.$lt = this.filters.price[1]
			let query = {
				...baseFilters,
				categories: { $in: all.map((c) => c.id) },
				name: { $regex: this.filters.query, $options: 'i' },
				calculatedPrice,
			}

			// Handle Brand filter explicitly at the root level using brandIds
			if (this.filters.brandIds && this.filters.brandIds.length > 0) {
				// If only one brand is selected, use $eq, otherwise use $in with $or
				if (this.filters.brandIds.length === 1) {
					query.brandId = this.filters.brandIds[0]
				} else {
					// Multiple brands - use $or with exact matches
					query.$or = this.filters.brandIds.map((brandId) => ({ brandId }))
				}
			} else if (this.filters.customFilters.Brand && this.filters.customFilters.Brand.length > 0) {
				// Fallback to using brand names if no IDs are available
				if (this.filters.customFilters.Brand.length === 1) {
					query.brand = this.filters.customFilters.Brand[0]
				} else {
					// Multiple brands - use $or with exact matches
					query.$or = this.filters.customFilters.Brand.map((brand) => ({ brand }))
				}
			}

			// If there are custom filters, add them to the query
			if (Object.keys(this.filters.customFilters).length > 0) {
				// Initialize an $and array for custom field filters
				query.$and = []

				// Add each custom filter as an $elemMatch within the $and array
				// Skip Price, Brand, and Rating as they are handled separately
				Object.entries(this.filters.customFilters).forEach(([filterName, values]) => {
					if (values && values.length && !['Price', 'Brand', 'Rating'].includes(filterName)) {
						query.$and.push({
							customFields: {
								$elemMatch: {
									name: filterName,
									value: { $in: values },
								},
							},
						})
					}
				})

				// Remove $and if it's empty after filtering
				if (query.$and && query.$and.length === 0) {
					delete query.$and
				}
			}

			// Handle birth kits differently
			if (this.birthKits) {
				return {
					...baseFilters,
					name: { $regex: this.filters.query, $options: 'i' },
					categories: { $in: all.map((c) => c.id) },
				}
			}

			// Add rating filter ONLY if explicitly selected by user
			console.log('Checking Rating filter:', this.filters.customFilters.Rating)
			if (this.filters.customFilters.Rating && this.filters.customFilters.Rating.length > 0) {
				// Handle multiple rating selections
				if (this.filters.customFilters.Rating.length > 1) {
					// Create an $or array for multiple rating ranges
					const ratingConditions = this.filters.customFilters.Rating.map((rating) => {
						const ratingValue = Number(rating)
						if (!isNaN(ratingValue)) {
							// Filter for ratings between the selected value and the next higher value
							return {
								rating: {
									$gte: ratingValue,
									$lt: ratingValue + 1,
								},
							}
						}
						return null
					}).filter((condition) => condition !== null)

					if (ratingConditions.length > 0) {
						// Add the $or condition to the query
						if (!query.$or) {
							query.$or = ratingConditions
						} else {
							// If $or already exists, we need to restructure the query
							const existingOr = query.$or
							delete query.$or
							query.$and = query.$and || []
							query.$and.push({ $or: existingOr })
							query.$and.push({ $or: ratingConditions })
						}
						console.log('Multiple rating filters applied:', ratingConditions)
					}
				} else {
					// Single rating selection
					const ratingValue = Number(this.filters.customFilters.Rating[0])
					console.log('Rating value parsed:', ratingValue, typeof ratingValue)
					if (!isNaN(ratingValue)) {
						// Filter for ratings between the selected value and the next higher value
						query.rating = {
							$gte: ratingValue,
							$lt: ratingValue + 1,
						}
						console.log('Rating filter applied:', query.rating)
					} else {
						console.log('Rating value is NaN')
					}
				}
			} else {
				console.log('No Rating filter found in customFilters')
			}
			// No default rating filter - allow products with any rating including no rating

			return query
		},
		mangoSort() {
			if (this.birthKits) return { name: 1 }
			if (this.sort == 'best_selling') return { totalSold: -1 }
			if (this.sort == 'newest') return { dateCreated: -1 }
			if (this.sort == 'alpha_desc') return { name: -1 }
			if (this.sort == 'alpha_asc') return { name: 1 }
			if (this.sort == 'avg_customer_review') return { rating: -1 }
			if (this.sort == 'price_asc') return { price: 1 }
			if (this.sort == 'price_desc') return { price: -1 }
			if (this.sort == 'featured') return { isFeatured: -1 }
		},
	},
}
</script>
